import { render, staticRenderFns } from "./CurrencyReview.vue?vue&type=template&id=78e16cc7&"
import script from "./CurrencyReview.vue?vue&type=script&lang=js&"
export * from "./CurrencyReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports